<template>
  <section class="landing">
    <div class="landing-inner">
      <h1>{{ title }}</h1>
      <h2>{{ subtitle }}</h2>
      <p>{{ description }}</p>

      <button class="cta" @click="goToBooking">
        {{ cta }}
      </button>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default defineComponent({
  setup() {
    const store = useStore();
    const router = useRouter();

    const title = store.state.landing.title;
    const subtitle = store.state.landing.subtitle;
    const description = store.state.landing.description;
    const cta = store.state.landing.cta;

    const goToBooking = () => {
      router.push("/booking");
    };

    return {
      title,
      subtitle,
      description,
      cta,
      goToBooking,
    };
  },
});
</script>

<style scoped>
.landing {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4rem 2rem;
  text-align: center;
  width: 100%;
}

.landing-inner {
  width: 66%;
  max-width: 900px;
  margin: 0 auto;
}

h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

h2 {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: #666;
}

p {
  margin-bottom: 2rem;
  line-height: 1.6;
}

.cta {
  background: #1e88e5;
  color: white;
  padding: 1rem 2rem;
  border: none;
  border-radius: 8px;
  font-size: 1.2rem;
  cursor: pointer;
}

.cta:hover {
  background: #1565c0;
}
</style>
